module.exports = __webpack_public_path__ + "zmenseni-prsou_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_5_after.jpg
// module id = 1285
// module chunks = 0